export default __webpack_public_path__ + "static/media/meal-light.cb6211e8.svg";